import ReportsTable from '../tables/ReportsTable';
import tableHeaders from '../tables/table-headers';
import {IInitialData, IAvgTimeDistData, IAvgTimeDistTableRow} from '../../types';
import PageBreak from '../PageBreak';

interface ISummaryProps {
    clientName: string;
    providerAvgTimeDistData: IInitialData<IAvgTimeDistData>;
    facilityAvgTimeDistData: IInitialData<IAvgTimeDistData>;
    standardType: string;
    countyCount: number;
}

const Summary = (props: ISummaryProps) => {

    const {
        clientName,
        providerAvgTimeDistData: _providerAvgTimeDistData,
        facilityAvgTimeDistData: _facilityAvgTimeDistData,
        standardType,
        countyCount
    } = props;

    const providerAvgTimeDist = _providerAvgTimeDistData.data || [];
    const facilityAvgTimeDist = _facilityAvgTimeDistData.data || [];

    const getLabel = (value: string) => {
        const parsedValue = +(value || '0') * 100;
        const color = parsedValue >= 90 ? 'green' : 'orange';
        return <span style={{color}}>{parsedValue.toFixed(2)}%</span>;
    };

    const getTableCellLabels = (row: IAvgTimeDistTableRow) => {
        return [
            row.specialty_name,
            getLabel(row['Large Metro_avg_pop_met_time']),
            getLabel(row['Large Metro_avg_pop_met_distance']),
            getLabel(row['Metro_avg_pop_met_time']),
            getLabel(row['Metro_avg_pop_met_distance']),
            getLabel(row['Micro_avg_pop_met_time']),
            getLabel(row['Micro_avg_pop_met_distance']),
        ];
    };

    return (
        <article>
            <h2 id='ii-summary-of-network-access-results'>II. Summary of Network Access Results</h2>
            <p>
                {clientName}'s primary service area encompasses {countyCount} counties. Each county has been individually assessed for the {standardType} regulatory
                provider and facility specialty types. These county-level access scores have been aggregated to provide an
                average summary of adequacy across the entire primary service area. The assessment used data provided by {clientName}.
                The network includes the {clientName} Medical Group and {clientName} Clinical Partners. The members utilized were the {clientName} employee plan members.{' '}
                <span style={{color: 'green'}}>Green</span> text indicates passing adequacy and <span style={{color: 'orange'}}>orange</span> text indicates not passing
                adequacy.
            </p>
            <h4 className="asset-header">
                [TABLE 3] PROVIDER SPECIALTY TYPES SUMMARY RESULTS 
            </h4>
            <ReportsTable
                rows={providerAvgTimeDist}
                headers={tableHeaders.providerSummaryTableHeaders}
                getTableCellLabels={getTableCellLabels}
                error={_providerAvgTimeDistData.error}
                loading={_providerAvgTimeDistData.loading}
                loadingRows={25}
                loadingColumns={7}            
            />
            <PageBreak />
            <ReportsTable
                rows={facilityAvgTimeDist}
                headers={tableHeaders.facilitySummaryTableHeaders}
                getTableCellLabels={getTableCellLabels}
                error={_facilityAvgTimeDistData.error}
                loading={_facilityAvgTimeDistData.loading}
                loadingRows={11}
                loadingColumns={7}
            />
        </article>
    );
};

export default Summary;
